import React, { useEffect, useState } from 'react'
import { MenuItem, Select, Typography } from '@mui/material'
import { doGet } from '../../util/do-fetch'

/**
 * Dropdown that loads saved prompt templates of a given type.
 * Selecting a template calls onSelect(body) and resets the selector.
 *
 * Props:
 *   type     – 'topic' | 'question'
 *   onSelect – callback(body: string)
 */
function PromptTemplatePicker({ type, onSelect }) {
	const [templates, setTemplates] = useState([])
	const [value, setValue]         = useState('')

	useEffect(() => {
		doGet(`/admin/prompt-templates?type=${type}`)
			.then(r => r.json())
			.then(data => setTemplates(data || []))
			.catch(console.error)
	}, [type])

	if (templates.length === 0) return null

	const handleChange = (e) => {
		const body = e.target.value
		if (body) {
			onSelect(body)
			setValue('')   // reset so same template can be re-selected
		}
	}

	return (
		<Select
			value={value}
			onChange={handleChange}
			displayEmpty
			size="small"
			sx={{ minWidth: 220, mb: 1 }}
		>
			<MenuItem value="" disabled>
				<Typography variant="body2" color="text.secondary">
					Load saved template…
				</Typography>
			</MenuItem>
			{templates.map(t => (
				<MenuItem key={t.id} value={t.body}>
					{t.name}
				</MenuItem>
			))}
		</Select>
	)
}

export default PromptTemplatePicker
